<template>
  <div class="container">

    <b-row>
      <b-col sm="4">
        <PredictionConfigList />
      </b-col>
      <b-col  sm="8" >
      <b-row align-h="center">
        <b-col sm="auto">
          <i v-on:click="showEditorView()" class="material-icons md-24 clickable">create</i>
        </b-col>
        <b-col sm="auto">
          <i v-on:click="showPerformanceView()" class="material-icons md-24 clickable">timeline</i>
        </b-col>
        <b-col sm="auto">
          <i v-on:click="showPassword" class="material-icons md-24 clickable">delete</i>
        </b-col>
      </b-row>
      <b-row align-h="center">
        <PredictionConfigEditor v-if="showEditor" :predictionConfigName="this.predictionConfigName" />
        <PredictionConfigPerformanceTable v-if="showPerformance"/>
        <div>
          <b-row class="my-1" v-if="activeConfig" >
            <b-col sm="8">
              <b-form-input class="passwordInput" v-model="password" type="password" placeholder="Please enter password"></b-form-input>
            </b-col>
            <b-col sm="4">
              <b-button v-on:click="archiveConfig">Confirm</b-button>
            </b-col>
          </b-row>
          <b-row class="my-1" v-if="showAlert">
            <b-col sm="12">
              <b-alert show variant="danger">Password incorrect</b-alert>
            </b-col>
          </b-row>
        </div>
      </b-row>
    </b-col>
    </b-row>
    <br>

  </div>
</template>

<script>
import PredictionConfigEditor from './PredictionConfigEditor.vue'
import PredictionConfigList from './PredictionConfigList'
import PredictionConfigPerformanceTable from './PredictionConfigPerformanceTable'
import * as PredictionConfigClient from '../clients/PredictionConfigClient'
import axios from 'axios'
export default {
  name: 'PredictionConfig',
  components: {
    PredictionConfigEditor, PredictionConfigList, PredictionConfigPerformanceTable
  },
  props: {
  },
  data () {
    return {
      title: 'PredictionConfig',
      predictionConfigName: "",
      showPerformance: false,
      showEditor: true,
      activeConfig: undefined,
      password: undefined,
      showAlert: false
    }
  },
  methods: {
    newConfig: function() {
      this.$router.push({name:"PredictionConfig", params:{configId:'new'}})
    },
    showPerformanceView: function() {
      this.showPerformance = true
      this.showEditor = false
      this.$router.push({query:{view:"performance"}})
    },
    showEditorView: function() {
      this.showPerformance = false
      this.showEditor = true
      this.$router.push({query:{view:"editor"}})
    },
    showPassword: function() {
      this.activeConfig = this.predictionConfigName
      this.showEditor = false
      this.showPerformance = false
      console.log(this.activeConfig)
      this.$router.push({query:{view:"delete"}})
    },
    archiveConfig: function () {
      this.showAlert = false
      return PredictionConfigClient.archivePredictionConfig(this.$route.params.configId, this.password)
      .then(() => {
        this.activeConfig = undefined
        this.showAlert = false
      })
      .catch (err => {
        if (err.response.status === 403) {
          this.showAlert = true
        }
      })
    }
  },
  watch: {
    $route(to, from) {
      this.predictionConfigName = this.$route.params.configId
    }
  },
  mounted () {
    this.predictionConfigName = this.$route.params.configId
  }
}

</script>
